import React, { Component } from "react";
import * as toast from "../Toast";

export default function NetworkDetector(ComposedComponent) {
  class NetworkDetector extends Component {
    state = {
      isDisconnected: false,
    };

    componentDidMount() {
      this.handleConnectionChange();
      window.addEventListener("online", this.handleConnectionChange);
      window.addEventListener("offline", this.handleConnectionChange);
    }

    componentWillUnmount() {
      window.removeEventListener("online", this.handleConnectionChange);
      window.removeEventListener("offline", this.handleConnectionChange);
    }

    handleConnectionChange = () => {
      const condition = navigator.onLine ? "online" : "offline";
      if (condition === "online") {
        const webPing = setInterval(() => {
          fetch("//google.com", {
            mode: "no-cors",
          })
            .then(() => {
              this.setState({ isDisconnected: false }, () => {
                return clearInterval(webPing);
              });
            })
            .catch((error) => console.log(error));
        }, 2000);
        return;
      }

      toast.warning(
        "You are on offline mode. please check your internet connection or try refresh page.",
        false
      );
      return this.setState({ isDisconnected: true });
    };

    render() {
      const { isDisconnected } = this.state;
      return (
        <>
          {isDisconnected && (
            <div className="internet-error text-center">
              <p>
                Internet connection lost, Please check your internet connection
                or try refreshing page!
              </p>
            </div>
          )}
          <ComposedComponent {...this.props} />
        </>
      );
    }
  }

  return NetworkDetector;
}
